define('payment/depositFee',['jquery', 'boxes/helpers/tooltip', 'boxes/events/feeEvent', 'all/comeon', 'all/paymentServices-toggles', 'payment/depositAmounts'], function ($, tooltip, feeEvent, comeon,
																																					  paymentServicesToggles, depositAmounts) {
	'use strict';

	var depositSummary = {};
	var depositBox = {};

	function fetchFeesFromServer(methodId, amount, currency, bonusId, aid, formTemplateCode) {

		var $formElements = depositBox.$box.find('.payment-method-form.' + formTemplateCode.toLowerCase()).find('input, textarea, select');
		var formParameters = $formElements.serialize();

		var otherParameters = {
			method: methodId,
			currency: currency,
			bonusId: bonusId,
			amount: amount,
			paymentOperation: 'deposit',
			aid: aid,
			isMobileDevice: 'false'
		};

		if (formParameters.length > 0) {
			formParameters += '&';
		}
		var parameters = formParameters + $.param(otherParameters);

		var ajaxPromise = comeon.promise.create();

		var feeUrl = '/PaymentFormDataService/getDepositFeesAndLimits';
		if (methodId === 1 || methodId === 2) {
			feeUrl = '/CreditCardIntegration/getCreditCardDepositFeesAndLimits';
		}
		if (paymentServicesToggles.useOldPaymentFormFlows()) {
			feeUrl = '/pp?flow=GetPaymentSummary';
		}

		$.get(feeUrl, parameters, function (dataResult) {
			if (dataResult.RESULT === 'OK') {

				var feesAndLimitsData;
				if (paymentServicesToggles.useOldPaymentFormFlows()) {
					feesAndLimitsData = dataResult;
				} else {
					feesAndLimitsData = {};
					$.extend(feesAndLimitsData, dataResult.depositLimitData);
					$.extend(feesAndLimitsData, dataResult.depositFeeAmounts);
					$.extend(feesAndLimitsData, dataResult.bonusAmountsData);
					$.extend(feesAndLimitsData, dataResult.defaultDepositAmounts);

				}

				depositAmounts.fillOptions(depositBox, feesAndLimitsData);

				var feeData = updateFees(depositBox, feesAndLimitsData, currency);
				ajaxPromise.resolve(feeData);
			} else {
				console.info('fetchFeesFromServer responseDataFromServer when not successful: ');
				console.info(dataResult);
			}
		});
		return ajaxPromise.promise();
	}


	function updateFees(depositBox, data) {
		var $feeBox = depositBox.$box.find('.fee-box');
		var $selectedBonusBox = depositBox.$box.find('.selected-bonus');

		showExchangeRate($feeBox, data);
		generateFeeBox($feeBox, data);
		updateBonusAmounts($selectedBonusBox, data);
		depositBox.model.providerId = data.PROVIDER;
		return data;
	}

	function updateBonusAmounts($selectedBonusBox, feeData) {
		if (feeData.PARAM_BONUS_TOTAL === null || feeData.PARAM_BONUS_TOTAL === 'undefined') {
			feeData.PARAM_BONUS_TOTAL = 0;
		}
		$selectedBonusBox.find('p').text(feeData.PARAM_BONUS_TOTAL);
	}


	function generateFeeBox($feeBox, feeData) {
		generateFee($feeBox, feeData);
		$feeBox.find('.deposit-amount').text(feeData.PARAM_AMOUNT + ' ' + feeData.PARAM_CURRENCY_ISO);
		$feeBox.find('.total-amount').text(feeData.PARAM_TOTAL_AMOUNT + ' ' + feeData.PARAM_PLAYER_CURRENCY);
	}

	function generateFee($feeBox, feeData) {
		var $fee = $feeBox.find('.fee');
		var $feeSpan = $fee.find('span');
		var $feeMoney = $feeBox.find('.fee-money');
		if (feeData.PARAM_FEE_TYPE !== 'FEE_NOT_ENABLED') {
			if (feeData.PARAM_FEE_TYPE === 'FEE_PROVIDER_MANAGED') {
				$feeSpan.text(feeData.PARAM_FEE_AMOUNT + feeData.PARAM_CURRENCY_ISO);
			} else {
				$feeSpan.text(feeData.PARAM_FEE + feeData.PARAM_FEE_EXT);
			}
			$feeMoney.text(feeData.PARAM_FEE_AMOUNT + ' ' + feeData.PARAM_CURRENCY_ISO);
			$fee.show();
			$feeMoney.show();
		} else {
			$fee.hide();
			$feeMoney.hide();
		}
	}

	function showExchangeRate($feeBox, feeData) {
		if (feeData.PARAM_RATE === 1.0) {
			$feeBox.find('.rate-label').hide();
			$feeBox.find('.rate-value').hide();
		} else {
			$feeBox.find('.rate-value').text((Math.round(parseFloat(feeData.PARAM_RATE) * 1000) / 1000 ) + ' ' + feeData.PARAM_CURRENCY_ISO + '/' + feeData.PARAM_PLAYER_CURRENCY);
			$feeBox.find('.rate-label').show();
			$feeBox.find('.rate-value').show();
		}
	}

	function getFeeFromServer(methodId, amount, currency, bonusId, formTemplateCode, aid) {
		return fetchFeesFromServer(methodId, amount, currency, bonusId, aid, formTemplateCode);
	}

	depositSummary.init = function (depositBoxReference) {
		depositBox = depositBoxReference;
	};
	depositSummary.updateFeesBox = function (methodId, amount, currency, bonusId, formTemplateCode, aid) {
		if (!isNaN(parseFloat(amount)) && isFinite(amount)) {
			$.when(getFeeFromServer(methodId, amount, currency, bonusId, formTemplateCode, aid)).done(function (data) {
				depositBox.$controller.trigger(feeEvent.UPDATE_TOOLTIP, data);
				depositBox.$controller.trigger(feeEvent.UPDATE_FEEOVER, data);
				console.info('updateFeesBox updated fee info with data: ' + data);
			});
		}
	};
	depositSummary.resetFees = function (methodId, currency, bonusId, formTemplateCode, aid, amount) {

		var promise = comeon.promise.create();
		$.when(getFeeFromServer(methodId, amount, currency, bonusId, formTemplateCode, aid)).done(function (data) {
			var $amountBox = depositBox.$box.find('.amount-box');
			tooltip.hidePopover($amountBox);
			depositBox.$controller.trigger(feeEvent.UPDATE_FEEOVER, data);
			console.info('resetFees set fee info with data: ' + data);
			promise.resolve();
		});


		return promise.promise();
	};
	return depositSummary;
});

